import React, { useState } from "react";

// Import internal components
import DialogInputQR from "./DialogInputQR";

// Import external components
import { Button } from "@mui/material";
import Add from "@mui/icons-material/Add";

export default function AddQRElement(props) {
    const [dialogOpen, setDialogOpen] = useState(false);

    const additionalInfo =
        "Please fill in the name for the QR code and the target URL where the QR needs to redirect to.";

    return (
        <>
            <Button
                onClick={() => setDialogOpen(true)}
                variant="contained"
                startIcon={<Add />}
                >
                    Add new QR code
                </Button>
            <DialogInputQR
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                redirectUrl={props.redirectUrl}
                title={"New QR"}
                titleDisable={false}
                additionalInfo={additionalInfo}
                addNewQR={props.addNewQR}
            />
        </>
    );
}
